export default __webpack_public_path__ + "static/media/office-icon.29874ef3.svg";